<template>
    <button
        class="btn-rounded btn-rounded--2 is-bold"
        type="button"
        @click="ridingschoolStore.toggleFilterOverlay">
        <span>Filter</span>
        <svgComponent
            :width="24"
            :height="24"
            class-name="icon-filter"
            icon-name="icon-filter"></svgComponent>
    </button>

    <Teleport to="body">
        <FilterOverlay :show="cOverlayOpen"></FilterOverlay>
    </Teleport>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import svgComponent from '../../../components/svgComponent.vue';
import FilterOverlay from './filter-overlay.component.vue';
import { useRidingschoolStore } from '../store/ridingschool.store';
import { useBodyLock } from '../../../composables/useBodyLock';

const ridingschoolStore = useRidingschoolStore();

const cOverlayOpen = computed(() => {
    useBodyLock(ridingschoolStore.filterOverlayIsOpen, 'hide-overflow');
    return ridingschoolStore.filterOverlayIsOpen;
});
</script>
